<mat-card>
    <h4>{{ 'FARM.CHECK_DATA' | translate }}:</h4>
    <div class="pt-3">
      <div class="proflie-field mb-3">
        <label>{{ 'FARM.COUNTRY.COUNTRY' | translate }}</label>
        <span>{{formParent.value.country | uppercase}}</span>
      </div>
      <div *ngIf="formParent.value.country=='es'">
        <div class="proflie-field mb-3">
          <label>{{ 'FARM.PROVINCE' | translate }}:</label>
          <span>{{ubication.province?.provinceName}}</span>
        </div>
        <div class="proflie-field mb-3">
          <label>{{ 'FARM.TOWN_HALL' | translate }}:</label>
          <span>{{ubication.townHall?.townHallName}}</span>
        </div>  
      </div>
      <div *ngIf="formParent.value.country=='pt'">
        <div class="proflie-field mb-3">
          <label>{{ 'FARM.DISTRICT' | translate }}:</label>
          <span>{{ubication.district?.districtName}}</span>
        </div>
        <div class="proflie-field mb-3">
          <label>{{ 'FARM.MUNICIPALITY' | translate }}:</label>
          <span>{{ubication.municipality?.municipalityName}}</span>
        </div>  
      </div>
      <div class="proflie-field mb-3">
        <label>{{ 'FARM.AREA' | translate }}:</label>
        <span>{{formParent.value?.area}}</span>
      </div>
      <div class="proflie-field mb-3">
        <label>{{ 'FARM.DESITE_TO.DESITE_TO' | translate }}:</label>
        <span >{{getTypesExplotation()}}</span>
      </div>
      <div class="proflie-field mb-3">
        <label>{{ 'FARM.OBJECTIVES_TO.OBJECTIVES_TO' | translate }}:</label>
        <span >{{getTypesObjectives()}}</span>
      </div> 
      <div class="proflie-field mb-3">
        <label>{{ 'FARM.ACCESS_ROAD.ACCESS_ROAD' | translate }}:</label>
        <span>{{ 'FARM.ACCESS_ROAD.'+ formParent.value.access | uppercase | translate}}</span>
      </div>
      <div class="proflie-field mb-3">
        <label>{{ 'FARM.INFO_FARM' | translate }}:</label>
        <span>{{formParent.value.information}}</span>
      </div>
    </div>
  </mat-card>